import { create } from 'zustand';

export type User = {
  name: string;
  email: string;
  tenantId: number; // User's home tenant (NOT NULL)
  isMaster: boolean; // Master user flag - only for TenantSwitcher and WhatsApp definition edits
};

type UserStore = {
  user: User | null;
  setUser: (user: User) => void;
};

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
}));
